import en from "./en.json";

const translations = {
  en: en,
};

export default translations;
